/**
 * Monta o menu lateral a partir do que os modulos declaram, filtrado por
 * permissao.
 *
 * Substitui o caminho antigo, em que a estrutura vinha da arvore do /appmenu e
 * era casada com os modulos por caminho de titulos ("Resources/Settings/
 * Workgroups"). Dois problemas com aquilo: o casamento por texto quebrava ao
 * renomear um no, e o catalogo precisava ser mantido so para o menu do proprio
 * app aparecer -- catalogo vazio, menu vazio.
 *
 * Agora a estrutura e do modulo e a permissao so decide visibilidade. A arvore
 * do /appmenu continua existindo para o que ela e boa: o menu ENTRE
 * aplicacoes, que o admin desenha.
 *
 * Funcao pura: nao importa Vue, Vite nem toca em localStorage.
 */
// Import relativo, nao pelo alias '@': e o que deixa o arquivo rodar sob
// `node --test` sem bundler, como os outros puros desta pasta.
import { can } from '../services/permission.js';

const DEFAULT_ICON = 'folder';
const EMPTY_URL = '#';

/**
 * @param {Array}  navs     declaracoes `nav` dos modulos
 * @param {Array}  codes  codigos do usuario, ou null quando desconhecido
 * @param {Array}  registered  codigos que existem no ambiente, ou null
 * @returns {Array} nos no formato que o LeftSidebar renderiza
 */
export function buildModuleMenu(navs = [], codes = null, registered = null) {
    const root = { children: new Map(), order: [] };

    navs
        .filter((nav) => nav?.title && nav?.route)
        .filter((nav) => !nav.dontshow)
        // A permissao e da folha. Pasta nao tem codigo proprio: ela aparece se
        // sobrou algum filho, senao sumiria levando junto um item permitido.
        .filter((nav) => can(nav.permission, codes, registered))
        .sort(compare)
        .forEach((nav) => insert(root, nav));

    return materialize(root);
}

function compare(a, b) {
    const sa = a.sequence ?? 0;
    const sb = b.sequence ?? 0;

    if (sa !== sb) {
        return sa - sb;
    }

    return String(a.title).localeCompare(String(b.title), 'pt-BR');
}

function insert(root, nav) {
    const segments = String(nav.section || '')
        .split('/')
        .map((s) => s.trim())
        .filter(Boolean);

    let node = root;

    segments.forEach((segment) => {
        if (!node.children.has(segment)) {
            node.children.set(segment, { title: segment, children: new Map(), order: [] });
            node.order.push({ kind: 'folder', key: segment });
        }
        node = node.children.get(segment);
    });

    node.order.push({ kind: 'leaf', nav });
}

function materialize(node) {
    return node.order
        .map((entry) => {
            if (entry.kind === 'leaf') {
                const { nav } = entry;
                return {
                    title: nav.title,
                    icon: nav.icon || DEFAULT_ICON,
                    url: nav.route,
                    accordion: false,
                    menu: [],
                };
            }

            const folder = node.children.get(entry.key);
            const children = materialize(folder);

            // Pasta que ficou sem filho visivel nao entra.
            if (children.length === 0) {
                return null;
            }

            return {
                title: folder.title,
                icon: DEFAULT_ICON,
                url: EMPTY_URL,
                accordion: true,
                menu: children,
            };
        })
        .filter(Boolean);
}
